import imageFragment from 'js/graphqlFragments/ImageFragment';

const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      PostLoginPage {
        homeVideoTitle
        attachedVideo {
          videoLink
          videoPreview {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${imageFragment()} 
`;
export default fetchData;
